import LowValueAsset from "./LowValueAsset";
import PeriodSpendings from "./PeriodSpendings";

export default class AlternativeContract {
  constructor(
    idInDb,
    number,
    date,
    externalId,
    lesseeId,
    lessorIds,
    isLowValue,
    isExceptionToArticle3OfIFRS16,
    isShortTerm,
    isIrrelevant,
    isVariableLeasePayments,
    isNotRentContract,
    periodSpendings,
    lowValueAssets,
    externalLink,
    externalLinkName,
    prolongationType,
    responsible) {

    this.idInDb = idInDb;
    this.number = number;
    this.date = date;
    this.externalId = externalId;
    this.lesseeId = lesseeId;
    this.lessorIds = lessorIds;
    this.isLowValue = isLowValue;
    this.isExceptionToArticle3OfIFRS16 = isExceptionToArticle3OfIFRS16;
    this.isShortTerm = isShortTerm;
    this.isIrrelevant = isIrrelevant;
    this.isVariableLeasePayments = isVariableLeasePayments;
    this.isNotRentContract = isNotRentContract;
    this.periodSpendings = periodSpendings;
    this.lowValueAssets = lowValueAssets;
    this.externalLink = externalLink;
    this.externalLinkName = externalLinkName;
    this.prolongationType = prolongationType;
    this.responsible = responsible;
  }

  static createFromData(data) {
    let periodSpendings = [];
    for (let i = 0; i < data.periodSpendings.length; i++) {
      const element = data.periodSpendings[i];
      periodSpendings.push(PeriodSpendings.createFromData(element));
    }

    let lowValueAssets = [];
    for (let i = 0; i < data.lowValueAssets.length; i++) {
      const element = data.lowValueAssets[i];
      lowValueAssets.push(LowValueAsset.createFromData(element));
    }

    return new AlternativeContract(
      data.idInDb,
      data.number,
      data.date,
      data.externalId,
      data.lesseeId,
      data.lessorIds,
      data.isLowValue,
      data.isExceptionToArticle3OfIFRS16,
      data.isShortTerm,
      data.isIrrelevant,
      data.isVariableLeasePayments,
      data.isNotRentContract,
      periodSpendings,
      lowValueAssets,
      data.externalLink,
      data.externalLinkName,
      data.prolongationType,
      data.responsible
    );
  }

  static createNew() {
    return new AlternativeContract(
      null,
      null,
      null,
      null,
      null,
      [],
      false,
      false,
      false,
      false,
      false,
      false,
      [],
      [],
      null,
      null,
      null,
      null
    );
  }
}
